import React, { PureComponent } from 'react';
import * as Session from 'data/SessionPlans/accessors';
import PropTypes from 'prop-types';
import { push, replace } from 'react-router-redux';
import { connect } from 'omni-common-ui';


export class AssignHomework extends PureComponent {
  componentWillMount() {
    this._redirectTo();
  }

  componentWillReceiveProps(nextProps) {
    this._redirectTo(nextProps);
  }

  _redirectTo(props = this.props) {
    const { sessionPlanId, unitId } = props;
    if (props.location.pathname.endsWith('assign-homework')) {
      props.push(
          props.buildRoute(`session/${sessionPlanId}/(unit/${unitId})`));
    }
  }

  render() {
    return <div>
      {this.props.children}
    </div>;
  }
}

AssignHomework.propTypes = {
  children: PropTypes.node.isRequired,
  groupId: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
  unitId: PropTypes.string.isRequired,
  sessionPlanId: PropTypes.string.isRequired,
  location: PropTypes.shape.isRequired,
};

function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const defaultSession = Session.getDefaultSession(state, groupId);
  const sessionPlanId = defaultSession && defaultSession.id;
  const unitId = Session.getFirstUnitOfSession(state, sessionPlanId);
  return {
    groupId,
    sessionPlanId,
    unitId,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    { replaceRoute: (path) => dispatch(replace(path)) },
  );
}


export default connect(mapStateToProps, mapDispatchToProps)(AssignHomework);



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/component.jsx